<template>
  <div class="VB_Error VB_Error--404">
    <div>
      <h2>
        Account not active
      </h2>
      <p>
        Your account is not active, so brochures are currently unavailable.
        Visit your
        <a href="https://viewmedica.com">ViewMedica.com</a> account to activate.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewmedicaBrochure404"
};
</script>

<style scoped>
a {
  color: white;
}
</style>
